import { render } from "./FeaturedIn.vue?vue&type=template&id=571da1d2&scoped=true"
import script from "./FeaturedIn.vue?vue&type=script&lang=js"
export * from "./FeaturedIn.vue?vue&type=script&lang=js"

import "./FeaturedIn.vue?vue&type=style&index=0&id=571da1d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-571da1d2"

export default script